module.exports = __webpack_public_path__ + "img/mokador.048991c6.jpeg";